import axios from "axios";
import {toast} from "../class/Notification";
import router from "@/router";
import {findObjectIndex} from "../class/Converter";
import store from "@/store";

const metaDataShape = (form) => {
    return {
        name: form.meta_name,
        meta_key: form.meta_key,
        value: form.meta_value,
        metaable_type: form.meta_type,
    }
}

export const meta_types = {
    'brand': 'برند',
    'order': 'سفارش',
    'product': 'محصول',
    'category': 'دسته‌بندی',
    'ticket': 'پیام',
}

export default {
    namespaced: true,
    state: {
        metas: [],
        trash: [],
        meta: {},
    },
    mutations: {
        setMeta(state, meta) {
            state.meta = meta
        },

        setMetas(state, metas) {
            state.metas = metas;
        },

        setTrash(state, metas) {
            state.trash = metas;
        },
        deleteMeta: (state, meta) => {
            state.metas.splice(
                findObjectIndex(store.getters["meta/metas"], meta),
                1
            );
            state.trash.splice(
                findObjectIndex(store.getters["meta/gettrash"], meta),
                1
            );
        },

    },
    actions: {
        setMetas({commit}, page = 1) {
            axios.get(`/metas`)
                .then(res => {
                    const data = res.data.data;
                    commit('setMetas', data)
                })
                .catch(error => {
                    console.log(error)
                })
        },

        async createmetas({commit}, form) {

            console.log(metaDataShape(form))

            await axios.post(`/metas`, metaDataShape(form))
                .then(async res => {
                    const meta = res.data.data;
                    await router.push({name: 'UpdateMeta', params: {meta: meta.id}})

                    toast("عملیات با موفقیت انجام شد", "عملیات با موفقیت انجام شد");
                })

        },

        updateMeta({commit}, form) {
            console.log(form)
            let formData = metaDataShape(form);
            axios
                .put(`/metas/${form.id}`, formData)
                .then((res) => {
                    const meta = res.data.data;
                    commit("setMeta", meta);

                    toast("عملیات با موفقیت انجام شد", "عملیات با موفقیت انجام شد");
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async showMeta({commit}, meta) {
            return await axios.get(`/metas/show/${meta.id}`)
        },


        setTrash({commit}) {
            axios.post('metas/trash')
                .then(res => {
                    const data = res.data.data;
                    commit("setTrash", data)
                })
                .catch(error => {
                    console.log(error)
                })
        },

        deleteMeta({commit}, meta) {
            axios
                .delete(`/metas/${meta.id}`)
                .then((res) => {
                    const deletedMeta = res.data.data;
                    store.dispatch('Meta/setMetas')
                    toast("عملیات با موفقیت انجام شد", "حذف  با موفقیت انجام شد.");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreMeta({commit}, meta) {
            axios.put(`metas/${meta.id}/restore`)
                .then(res => {
                    const meta = res.data.data;
                    store.dispatch('Meta/setTrash')
                    toast("عملیات با موفقیت انجام شد", "بازیابی  با موفقیت انجام شد.");
                })
                .catch(error => {
                    console.log(error)
                })
        },
        async showCustomMeta({commit}, meta) {
            return await axios.post(`metas/show/withparameter`, meta)

        },
    },


    getters: {
        metas: (state) => state.metas,
        getTrash: (state) => state.trash,
        meta: (state) => state.meta,
    },
}